module.exports = __webpack_public_path__ + "static/img/list-item-7.9feaf09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-7.png
// module id = anKS
// module chunks = 1